"use client";
/* PublicationCard — Double-Bezel with year badge */
import React from "react";

interface PublicationCardProps {
  title: string;
  authors: string;
  venue: string;
  year: number;
  citationHref?: string;
  className?: string;
}

export const PublicationCard = ({
  title,
  authors,
  venue,
  year,
  citationHref,
  className,
}: PublicationCardProps) => {
  return (
    <article
      className={`group rounded-[var(--radius-xl)] border border-[var(--color-border)] bg-[var(--color-surface-elevated)] p-2 transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] hover:-translate-y-1 hover:shadow-[0_32px_64px_rgba(0,0,0,0.08)] ${className || ""}`}
    >
      <div className="rounded-[var(--radius-lg)] p-6">
        <div className="mb-4 flex items-start justify-between gap-4">
          <h3 className="text-base font-bold leading-snug text-[var(--color-ink)]">
            {title}
          </h3>
          <span className="shrink-0 inline-flex items-center rounded-full bg-[var(--color-accent)]/10 px-3 py-1 text-xs font-semibold text-[var(--color-accent)]">
            {year}
          </span>
        </div>
        <p className="mb-2 text-sm text-[var(--color-muted)]">{authors}</p>
        <p className="mb-4 text-xs text-[var(--color-muted)]">{venue}</p>
        {citationHref && (
          <a
            href={citationHref}
            className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--color-accent)] transition-all duration-300 hover:gap-3"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Citation
            <span className="text-xs">→</span>
          </a>
        )}
      </div>
    </article>
  );
};
